import { Injectable } from '@angular/core';
import {
  MerchandiseService,
  MerchandisingContext,
} from '@epicuro-next/data/merchandise';
import {
  selectAccountId,
  selectSiteId,
} from '@epicuro-next/state/session-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import {
  catchError,
  map,
  switchMap,
  take,
  withLatestFrom,
} from 'rxjs/operators';

import {
  loadPersonalMediaItems,
  loadPersonalMediaItemsError,
  loadPersonalMediaItemsSuccess,
} from './personal-media-items.actions';

@Injectable()
export class PersonalMediaItemsEffects {
  constructor(
    private actions$: Actions,
    private merchandiseService: MerchandiseService,
    private store: Store,
  ) {}

  public loadPersonalMediaItems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPersonalMediaItems),
      withLatestFrom(
        this.store.pipe(select(selectSiteId)),
        this.store.pipe(select(selectAccountId)),
      ),
      switchMap(([, siteId, accountId]) =>
        this.merchandiseService
          .getSiteMerchandisingMedia(
            MerchandisingContext.SuggestPromotionMedias,
            siteId as string,
            accountId as string,
          )
          .pipe(
            take(1),
            map((mediaItems) =>
              loadPersonalMediaItemsSuccess({
                mediaItems,
              }),
            ),
            catchError((err) => [
              loadPersonalMediaItemsError({
                error: err.message,
              }),
            ]),
          ),
      ),
    ),
  );
}
